'use client';

import { useEffect, useRef } from 'react';
import { Info } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const COUNTRY_CODES = [
  { code: '+385', label: 'HR (+385)' },
  { code: '+49', label: 'DE (+49)' },
  { code: '+43', label: 'AT (+43)' },
  { code: '+39', label: 'IT (+39)' },
  { code: '+44', label: 'UK (+44)' },
  { code: '+1', label: 'US (+1)' },
];

export default function PhoneInput({ form }: { form: any }) {
  const { register, setValue, watch } = form;

  const initialized = useRef(false);

  const phone = watch('phone');
  const countryCode = watch('countryCode') || '+385';
  const phoneNumber = watch('phoneNumber') || '';

  /**
   * ✅ INIT samo jednom (bez loopa)
   */
  useEffect(() => {
    if (!phone || initialized.current) return;

    const matched = COUNTRY_CODES.find((c) => phone.startsWith(c.code));

    if (matched) {
      setValue('countryCode', matched.code, { shouldDirty: false });
      setValue(
        'phoneNumber',
        phone.replace(matched.code, '').replace(/\D/g, ''),
        { shouldDirty: false },
      );
    } else {
      setValue('phoneNumber', phone.replace(/\D/g, ''), {
        shouldDirty: false,
      });
    }

    initialized.current = true;
  }, [phone, setValue]);

  /**
   * ✅ Merge bez gledanja phone
   */
  useEffect(() => {
    const sanitized = phoneNumber.replace(/\D/g, '');
    const fullPhone = `${countryCode}${sanitized}`;

    setValue('phone', fullPhone, { shouldDirty: true });
  }, [countryCode, phoneNumber, setValue]);

  return (
    <div className='space-y-2'>
      <div className='flex gap-2'>
        <Select
          value={countryCode}
          onValueChange={(value) => setValue('countryCode', value)}>
          <SelectTrigger className='w-[130px] shadow-none'>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COUNTRY_CODES.map((c) => (
              <SelectItem key={c.code} value={c.code}>
                {c.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Input
          placeholder='Broj mobitela'
          type='tel'
          {...register('phoneNumber')}
          className='flex-1 h-9 border-gray-200 shadow-none'
        />
      </div>{' '}
      {/* <label className='font-medium text-sm flex items-center gap-2'>
        <Info size={16} />
      </label> */}
    </div>
  );
}
